import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { ParkingService } from '@shared/components/parking-lot/services/parking.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CancelBookingRequest, CancelBookingType, ModalData } from '@core/models/api.response.modal';
import { GroupUserService } from '@core/services/group-user.service';
import { ToastService } from '@shared/services/toast.service';
import { USER_ROLES } from '@shared/constant/shared.constant';
import { autoUnsubWith } from '@shared/services/utility.abstract';

@Component({
  selector: 'app-cancel-booking',
  templateUrl: './cancel-booking.component.html',
  styleUrls: ['./cancel-booking.component.scss']
})
export class CancelBookingComponent implements OnInit {
  readonly destroyRef = inject(DestroyRef);
  totalAmount: number;
  fetchModalData: ModalData;
  userRoles = USER_ROLES;
  constructor(  
    private readonly parkingService: ParkingService,
    private readonly ref: DynamicDialogRef,
    private readonly groupUserService: GroupUserService,
    private readonly config: DynamicDialogConfig,
    private readonly toastService: ToastService
  ) { }

  ngOnInit(): void {
    this.fetchModalData = this.config.data;
    this.calculateTotalAmount();
  }

  continue(): void {
    this.ref.close();
  }

  confirm(): void {
    const request: Partial<CancelBookingRequest> = {
      bookingId: this.fetchModalData.id,
      type: 1,
    };
    if (this.fetchModalData.role === this.userRoles.GROUP_USER) {
      Object.assign(request, {
        cancelBookingType: CancelBookingType.FullCancelBooking,
        slotCount: 0
      });
    }

    const cancelService = this.fetchModalData.role === this.userRoles.GROUP_USER
      ? this.groupUserService
      : this.parkingService;
    const cancelRequest = this.fetchModalData.role === this.userRoles.GROUP_USER
      ? cancelService.getCancelbookingById(request)
      : cancelService.cancelBookingBySuperAdminOneTime(request);
    cancelRequest
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: ({ message }) => this.handleSuccessResponse(message),
      error: (error) => {
        this.toastService.showToastMessage('error', 'Error', error.error?.message || 'An error occurred.');
      }
    });
  }

  calculateTotalAmount(): void {
    if (this.fetchModalData) {
      const { usedCredit, total } = this.fetchModalData;
      if (usedCredit !== undefined && total !== undefined) {
        if (usedCredit > 0 && total === 0) {
          this.totalAmount = usedCredit;
        } else if (usedCredit === 0 && total > 0) {
          this.totalAmount = total;
        } else if (usedCredit > 0 && total > 0) {
          this.totalAmount = total + usedCredit;
        } else {
          this.totalAmount = total
        }
      }
    }
  }

  handleSuccessResponse(message: string): void {
    
    this.toastService.showToastMessage('success', 'Success', message);
    setTimeout(() => {
      this.ref.close(message);
    }, 1000);
  }

  closeDialog(): void {
    this.ref.close();
  }
}
